<template>
  <div class="reset-shell">
    <PageLoader v-bind:storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="snackbar" color="#427D2D" right :timeout="3000">
      <v-layout wrap>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="snackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>

    <div class="reset-card">
      <span class="card-rail"></span>

      <div class="card-brand">
        <span class="brand-badge"><v-icon size="22">mdi-lock-reset</v-icon></span>
        <span class="brand-copy">
          <span class="brand-eyebrow">Sarpa Odisha</span>
          <span class="brand-title">Forgot password?</span>
        </span>
      </div>

      <p class="card-lead">
        Enter your username and registered phone number. We'll send a one-time
        password to reset your account.
      </p>

      <form class="fields" autocomplete="on" @submit.prevent="sentOTP">
        <label class="field-label" for="reset-username">Username</label>
        <div class="field" :class="{ 'is-focused': focus === 'user' }">
          <v-icon size="19" class="field-icon">mdi-account-outline</v-icon>
          <input
            id="reset-username"
            v-model="userName"
            type="text"
            class="field-input"
            placeholder="Enter your username"
            autocomplete="username"
            spellcheck="false"
            @focus="focus = 'user'"
            @blur="focus = null"
          />
        </div>

        <label class="field-label field-gap" for="reset-phone">Phone number</label>
        <div class="field" :class="{ 'is-focused': focus === 'phone' }">
          <v-icon size="19" class="field-icon">mdi-phone-outline</v-icon>
          <input
            id="reset-phone"
            v-model="phone"
            type="tel"
            inputmode="numeric"
            class="field-input"
            placeholder="Registered phone number"
            autocomplete="tel"
            @focus="focus = 'phone'"
            @blur="focus = null"
          />
        </div>

        <button type="submit" class="submit-btn" :disabled="appLoading">
          <span v-if="!appLoading">Send OTP</span>
          <span v-else>Sending&hellip;</span>
          <v-icon v-if="!appLoading" size="18" class="btn-arrow">mdi-arrow-right</v-icon>
        </button>
      </form>

      <div class="card-foot">
        <router-link to="/login" class="back-link">
          <v-icon size="15">mdi-arrow-left</v-icon>
          Back to login
        </router-link>
        <router-link to="/supportPage" class="quiet-link">Need help?</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      appLoading: false,
      ServerError: false,
      snackbar: false,
      timeout: 5000,
      msg: null,
      phone: null,
      userName: "",
      status: "",
      focus: null,
    };
  },
  methods: {
    sentOTP() {
      //the endpoint needs both, and a silent no-op reads as a dead button
      if (!this.userName) {
        this.msg = "Please enter your username.";
        this.snackbar = true;
        return;
      }
      if (!this.phone) {
        this.msg = "Please enter your registered phone number.";
        this.snackbar = true;
        return;
      }

      var userData = {};
      userData["phone"] = this.phone;
      userData["userName"] = this.userName;
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/users/resetotp/password/Officials",
        data: userData,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.status = response.data.status;
            this.msg = "OTP  Sent Successfully";
            this.$router.push({
              path: "/resetPassword",
              query: { phone: this.phone, userName: this.userName },
            });

            this.snackbar = true;
          } else {
            this.msg = response.data.msg;
            this.snackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
/* ================= shell =================
   The same emerald system as the login screen, so arriving here from "Forgot
   Password?" does not feel like leaving the product. */
.reset-shell {
  --accent: #10b981;
  --ink: #047857;
  --tint: #f0fdf9;
  --tint-line: #d2efe3;
  --line: #e7eef3;
  --muted: #64748b;

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 20px;
  background: linear-gradient(160deg, #f6fbf8 0%, #eefaf3 55%, #e6f7ee 100%);
}

/* ================= card ================= */
.reset-card {
  position: relative;
  overflow: hidden;
  width: 100%;
  max-width: 430px;
  padding: 30px 30px 26px 32px;
  border: 1px solid var(--tint-line);
  border-radius: 18px;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04),
    0 18px 44px -22px rgba(15, 23, 42, 0.25);
}
.card-rail {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: linear-gradient(180deg, var(--accent) 0%, var(--ink) 100%);
}

/* ================= brand ================= */
.card-brand {
  display: flex;
  align-items: center;
  gap: 13px;
}
.brand-badge {
  flex: 0 0 auto;
  width: 46px;
  height: 46px;
  border-radius: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* a step below the brand emerald so the white glyph clears 3:1 */
  background: linear-gradient(135deg, #0ea97a 0%, var(--ink) 100%);
  box-shadow: 0 8px 20px -8px rgba(5, 150, 105, 0.55);
}
.brand-badge .v-icon {
  color: #ffffff !important;
}
.brand-copy {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.brand-eyebrow {
  font-family: poppinsmedium, poppinsregular, sans-serif;
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.7px;
  text-transform: uppercase;
  color: var(--ink);
}
.brand-title {
  margin-top: 2px;
  font-family: poppinssemibold, poppinsregular, sans-serif;
  font-size: 21px;
  line-height: 1.2;
  letter-spacing: -0.5px;
  color: #1a2e23;
}
.card-lead {
  margin: 16px 0 0 0;
  font-family: poppinsregular, sans-serif;
  font-size: 13px;
  line-height: 1.55;
  color: var(--muted);
}

/* ================= fields ================= */
.fields {
  margin-top: 22px;
}
/* not .mt-16: Vuetify already owns that name at 64px !important */
.field-gap {
  margin-top: 18px;
}
.field-label {
  display: block;
  margin-bottom: 6px;
  font-family: poppinsmedium, poppinsregular, sans-serif;
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  color: #8496a5;
}
.field {
  display: flex;
  align-items: center;
  height: 46px;
  padding: 0 14px;
  border: 1px solid var(--line);
  border-radius: 11px;
  background: #fcfefd;
  transition: border-color 0.25s ease, background 0.25s ease,
    box-shadow 0.25s ease;
}
.field:hover {
  border-color: var(--tint-line);
}
.field.is-focused {
  border-color: var(--accent);
  background: #ffffff;
  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.14);
}
.field-icon {
  flex: 0 0 auto;
  margin-right: 10px;
  color: #9fb0bd !important;
  transition: color 0.25s ease;
}
.field.is-focused .field-icon {
  color: var(--ink) !important;
}
.field-input {
  flex: 1 1 auto;
  min-width: 0;
  height: 100%;
  border: none;
  outline: none;
  background: transparent;
  font-family: poppinsregular, sans-serif;
  font-size: 14px;
  color: #1a2e23;
}
.field-input::placeholder {
  color: #a7b6c2;
  opacity: 1;
}

/* ================= submit ================= */
.submit-btn {
  width: 100%;
  height: 46px;
  margin-top: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: none;
  border-radius: 11px;
  cursor: pointer;
  background: linear-gradient(135deg, var(--accent) 0%, var(--ink) 100%);
  color: #ffffff;
  font-family: poppinssemibold, poppinsregular, sans-serif;
  font-size: 13px;
  letter-spacing: 0.3px;
  box-shadow: 0 8px 20px -8px rgba(5, 150, 105, 0.5);
  transition: transform 0.25s ease, box-shadow 0.25s ease, filter 0.25s ease;
}
.submit-btn .btn-arrow {
  color: #ffffff !important;
  transition: transform 0.2s ease;
}
.submit-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  filter: brightness(1.06);
  box-shadow: 0 12px 26px -10px rgba(5, 150, 105, 0.55);
}
.submit-btn:hover:not(:disabled) .btn-arrow {
  transform: translateX(3px);
}
.submit-btn:disabled {
  cursor: default;
  filter: saturate(0.55) brightness(0.92);
  box-shadow: none;
}

/* ================= foot ================= */
.card-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 22px;
  padding-top: 16px;
  border-top: 1px solid var(--line);
}
.back-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: poppinsmedium, poppinsregular, sans-serif;
  font-size: 12.5px;
  color: var(--ink) !important;
  text-decoration: none;
}
.back-link .v-icon {
  color: var(--ink) !important;
  transition: transform 0.2s ease;
}
.back-link:hover {
  text-decoration: underline;
}
.back-link:hover .v-icon {
  transform: translateX(-3px);
}
.quiet-link {
  font-family: poppinsregular, sans-serif;
  font-size: 12.5px;
  color: var(--muted) !important;
  text-decoration: none;
}
.quiet-link:hover {
  color: var(--ink) !important;
  text-decoration: underline;
}

@media (max-width: 480px) {
  .reset-shell {
    padding: 28px 14px;
  }
  .reset-card {
    padding: 24px 20px 22px 22px;
  }
  .brand-title {
    font-size: 19px;
  }
}
</style>
